// extracted by mini-css-extract-plugin
export default {"link":"bN-z","disabled":"cN-z"};